import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat.js";

dayjs.extend(advancedFormat);

export function formatDateRange(val: Date, period: number): string {
  const endDate = dayjs(val);
  const startDate = endDate.subtract(period, "day");

  // If start and end are in the same month and year, only show day for the start
  if (
    startDate.month() === endDate.month() &&
    startDate.year() === endDate.year()
  ) {
    return `${startDate.format("Do")} - ${endDate.format("Do MMM YYYY")}`;
  } else {
    return `${startDate.format("Do MMM YYYY")} - ${endDate.format("Do MMM YYYY")}`;
  }
}
